module.exports = __webpack_public_path__ + "img/staff-group-icon.6960cdd3.svg";